import React from "react";

function SessionInfoLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <circle cx="32" cy="32" r="32" fill="white" />
      <path
        d="M32 64C14.3264 64 0 49.6736 0 32C0 14.3264 14.3264 0 32 0C49.6736 0 64 14.3264 64 32C64 49.6736 49.6736 64 32 64ZM28.8 28.8V48H35.2V28.8H28.8ZM28.8 16V22.4H35.2V16H28.8Z"
        fill="#7950FF"
      />
    </svg>
  );
}

export default SessionInfoLogo;
